import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProductById, updateProduct } from '../../services/productService/productService';
import './EditProduct.css';

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState({
    name: '',
    description: '',
    specs: '',
    image: '',
    category: '',
  });

  useEffect(() => {
    getProductById(id)
      .then(data => setProduct(data))
      .catch(err => console.error('Failed to fetch product:', err));
  }, [id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setProduct(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await updateProduct(id, product);
      alert('Product updated successfully');
      navigate('/admin/dashboard');
    } catch (error) {
      alert('Failed to update product');
      console.error(error);
    }
  };

  return (
    <div className="edit-container">
      <h2 className="edit-heading">Edit Product</h2>
      <form onSubmit={handleSubmit} className="edit-form">
        <input
          type="text"
          name="name"
          value={product.name}
          onChange={handleChange}
          placeholder="Product Name"
          required
          className="edit-input"
        />
        <textarea
          name="description"
          value={product.description}
          onChange={handleChange}
          placeholder="Description"
          rows={3}
          className="edit-textarea"
        />
        <textarea
          name="specs"
          value={product.specs}
          onChange={handleChange}
          placeholder="Technical Specs"
          rows={3}
          className="edit-textarea"
        />
        <input
          type="text"
          name="image"
          value={product.image}
          onChange={handleChange}
          placeholder="Image URL"
          className="edit-input"
        />
        <select
          name="category"
          value={product.category}
          onChange={handleChange}
          className="edit-select"
        >
          <option value="">Select Category</option>
          <option value="PVC Cable Extruder">PVC Cable Extruder</option>
          <option value="PVC Compound Machine">PVC Compound Machine</option>
          <option value="PVC Mixture">PVC Mixture</option>
          <option value="Stranding Machine">Stranding Machine</option>
          <option value="Armouring Machine">Armouring Machine</option>
          <option value="Core-Laying Machine">Core-Laying Machine</option>
          <option value="Copper Buncher">Copper Buncher</option>
          <option value="Take-Ups">Take-Ups</option>
          <option value="Pay-Offs">Pay-Offs</option>
          <option value="Coiling Machines">Coiling Machines</option>
        </select>

        <button type="submit" className="edit-submit-btn">Update Product</button>
      </form>
    </div>
  );
};

export default EditProduct;
